// Rich gradient bases for the topic tiles so a grid keeps its colour rhythm
// even when a topic's (fragile Unsplash) image fails to load. Shared by the
// homepage "Resources by Topic" grid and the /family topic grid (HAP-4913) so
// the two read as a matched pair.
export default [
	'from-ncfic-blue-600 to-ncfic-blue-900',
	'from-ncfic-green-600 to-ncfic-green-900',
	'from-ncfic-maroon-500 to-ncfic-red-300',
	'from-ncfic-blue-500 to-ncfic-green-900',
	'from-gray-700 to-ncfic-blue-900',
	'from-ncfic-green-500 to-ncfic-blue-900',
	'from-ncfic-blue-700 to-ncfic-maroon-500',
	'from-ncfic-green-700 to-gray-900',
	'from-ncfic-blue-800 to-black',
]
